// extracted by mini-css-extract-plugin
export default {"image":"event-info-section_image__IydSK","imageWrapper":"event-info-section_imageWrapper__JNkru","content":"event-info-section_content__NUSAE"};